
var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "€{{amount}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

//--------------------------   //   Ajax Cart
    const addToCart = $("[data-add-to-cart]");
    const cartCounter = $(".quick-cart--cart-has-item");


    for (let i = 0; i < addToCart.length; i++) {

      addToCart[i].addEventListener('click', function(event) {
      
        event.preventDefault();
                document.querySelector(".product-form__cart-submit").classList.add("bttn--loading");
        let inputValue = $(".pro-swatch input:checked").data("value");    
        
        var formID = $(this).parents("form").attr("id");
          
        if( document.querySelector(".length-check").classList.contains('length--2') ){
          const sizeElement = document.querySelectorAll(".product__meta .Select-size");
             var element = document.querySelectorAll(".product__meta .Select-size input:checked").length;

       if(element > 0 || sizeElement.length == 0){
          addProductToCart(formID);
      }
       else{
       document.querySelector("body").classList.add("size_not_selected");
        document.querySelector(".product-form__cart-submit").classList.remove("bttn--loading");
        
    }
        
        }
        else{              
   addProductToCart(formID);
        }
        
      });

    }

    function addProductToCart(formID) {
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: $('#' + formID)
        .serialize(),
        success: addToCartOk,
        error: addToCartFail,

      });
    }
    function addToCartFail() {
      $(".js-ajax-cart-modal-content").html('The product you are trying to add is out of stock.');
      $(".ajax-cart__modal").fadeIn();
      document.querySelector(".product-form__cart-submit").classList.remove("bttn--loading");
      openCartOverlay();
    }
    function addToCartOk(product) {
    cartCountIcon();
      openCartDrawer();  fetchCart();
              document.querySelector(".product-form__cart-submit").classList.remove("bttn--loading");
    
      openCartOverlay();

    }
    fetchCart();
    function fetchCart() {
      $.ajax({
        type: 'GET',
        url: '/cart.js',
        dataType: 'json',
        success: function(cart) {


          if (cart.item_count === 0) {        
            $(".ajax-cart__drawer").addClass("cart-is-empty");
            $(".recommendation--popup-no-active").hide();
               $(".recommendation--cart .products--list").each(function(){
             $(this).show();
          });
          } else {
            $(".recommendation--cart .products--list").show();
            $(".recommendation--popup-no-active").hide();
            renderCart(cart);
            $(".ajax-cart__drawer").removeClass("cart-is-empty")
          }

        },
      });
    }

    function changeItem(line, callback) {
      const quantity = 0;
      $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: 'quantity=' + quantity + '&line=' + line,
        dataType: 'json',
        success: function(cart) {
          if ((typeof callback) === 'function') {
            callback(cart);
       
          } else {

            fetchCart();

          }
        },
      });
    }

    function renderCart(cart) {
      clearCartDrawer();
      $(".quick-cart__indicator-inner").text(cart.count)
let total = cart.total_price;
let amount = $("[data-amount]").attr("data-amount");
      if((total / 100) > amount){
        $(".progress-bar-inner").animate({width:"100%"});
           $("[data-amount]").text(" ");
        $(".shipping-message-0").text($("[data-text]").attr("data-text"));
      }
      else{
      let per = ((total  / 100) / amount) * 100;
      const am = Math.round(amount - (total  / 100));
        $("[data-amount]").text(am);
          $(".progress-bar-inner").animate({width:`${per}%`});
        $(".shipping-message-0").text($(".shipping-message-0").attr("data-shipping-text"));
      }
      var giftCard = false;
      cart.items.forEach(function(item, index) {
        
        
          $(".recommendation--cart .products--list").each(function(){
          var d = $(this),
              val = d.data("id");
        
            if(item.product_id == val){
              d.hide();
            }
          
                 });
        
        
        
        
        
        
    let options = item.options_with_values;
    
        var hml2,
            hml = [];
        
        for (let i = 0; i < options.length; i++) {
          if(item.options_with_values[i].name != "Title" && item.options_with_values[i].value != "Default Title"){
            hml2 = '<h4>' + item.options_with_values[i].name + ': ' + '<span>' + item.options_with_values[i].value + '</span>' + '</h4>';
          }
            hml.push(hml2);
        }
        const productTitle = '<div class="ajax-cart-item__title u-h5 lh-130 color-brown"><a href="' + item.url + '">' + item.product_title + '</a></br><span class="ajax-cart-item__price th_bundle_discount_text"></span></div>';
        const productvariant = '<div class="options">'+hml+'</div>';
        const productImage = '<a href="' + item.url + '"><img class="ajax-cart-item__image" src="' + item.image + '" ></a>';
        const orginalPrice = `<div class="ajax-cart-item__price ajax-cart-item__compare th_item_price">${Shopify.formatMoney(item.original_price, window.theme.moneyFormat)}</div>`
        const productPrice = '<div class="ajax-cart-item__price th_item_line_price">' + Shopify.formatMoney(item.line_price, window.theme.moneyFormat) + '</div>';
        let finalPrice =  productPrice;
        if (item.original_price != item.line_price){
          finalPrice =  `<div class="ajax-price__wrapper">${orginalPrice}${productPrice}</div>`;
        }

        if(item.gift_card == true ){
          giftCard = true;
        } 
    //    const productQuantity = '<div class="ajax-cart-item__quantity">' + 'Quantity: ' + item.quantity + '</div>';
       const productQuantity = '<div class="quantity--main-grid">'+'<input type="button" value="-" class="qtyminus" field="quantity" />' +  '<input ' +  'type="text"' +  ' id="quart"' +  ' name="quantity"' +  ' value="'+ item.quantity + '"' +  ' min="1" ' +  'class="qty"' + ' oninput=" ' + "this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');" + ' " ' + ' >'  + '<input type="button" value="+" class="qtyplus" field="quantity" />'+'</div>';
        const productRemove = '<div class="ajax-cart-item__remove th_pb_remove_cart_item ' + "js-ajax-remove-from-cart" + '">Remove</div>';
        console.log(item);
        const concatProductInfo = '<div class="ajax-cart-item__single" data-id="'+ item.product_id +'" data-line="' + Number(index + 1) + '">' +'<div class="ajax-cart-productImage">' + productImage + '</div>'+ '<div class="ajax-cart-productContent" ' + 'data-variant-id="' +  item.variant_id  +'"' + '>' +  productTitle+ productvariant  +  productQuantity + finalPrice + productRemove + '</div>' +'</div>';
        var jsAjaxInnerHtml = $(".ajax-cart--products").html();
        $(".ajax-cart--products").html(jsAjaxInnerHtml + concatProductInfo);
        cartDrawerQuantityAdd();
        cartDrawerQuantityClose();
      });
      
      $("[data-subtotal]").html(Shopify.formatMoney(total, window.theme.moneyFormat));



        if(giftCard){
          $('.progress-bar-outer').css('display','none');
          $('.progress-bar-outerText').css('display','none');
        } else {
          $('.progress-bar-outer').css('display','block');
          $('.progress-bar-outerText').css('display','block');
        }
      
      
      let removeFromCart = document.querySelectorAll(".js-ajax-remove-from-cart");

      for (let i = 0; i < removeFromCart.length; i++) {
        removeFromCart[i].addEventListener('click', function() {
          const line = this.parentNode.parentNode.getAttribute('data-line');
          cartCountIcon();

          changeItem(line);
        });
      }

      loadRecommendations();

    }

    function loadRecommendations(){
      var id = document.querySelector('.ajax-cart-item__single').dataset.id;
      console.log(id);
        var url = window.Shopify.routes.root + "recommendations/products?section_id=cart-recommendation&product_id=" + id + "&limit=3";
      return fetch(url).then(function (response) {
        return response
          .text()
          .then(function (content) {
            var container = document.createElement("div");
            container.innerHTML = content;
            const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent);
            const forReplace = this.container.querySelector('.complete-the-look');
            if(isMobile || window.innerWidth < 1025){
              console.log('here2');
              $(".mobile-cart-drawer-recommendation .complete-the-look" ).replaceWith(forReplace);
            }else {
              console.log('here');
              $(".desktop-cart-drawer-recommendation .complete-the-look" ).replaceWith(forReplace);
            }
       
            toggleATC();
          })
          .catch((e) => {
            console.error(e);
          });
      });
    }
  
    function toggleATC(){
      
$(".product__meta .complete-the-look .header-option").click(function () {
  $(this).next().slideToggle();
  $(this).parent("ul").parent("div").siblings("div").find("div").slideUp();
  $(this)
    .parents(".products--list")
    .siblings(".products--list")
    .find(".selectors div")
    .slideUp();
    $('.cartDrawer--overflow').css('overflow','unset');
});
$(".header-option").click(function () {
  $(this)
    .parents(".products--list")
    .find(".recommendation--popup-no-active")
    .fadeIn();
    $('.cartDrawer--overflow').css('overflow','unset');
});
$(".close--recommendation").click(function () {
  $(this)
    .parents(".products--list")
    .find(".recommendation--popup-no-active")
    .fadeOut();
    $('.cartDrawer--overflow').css('overflow','auto');
});
$(document).on("click", ".recommendation--popup", function () {
  $(".recommendation--popup-no-active").fadeOut();
  $('.cartDrawer--overflow').css('overflow','auto');
});
$(document).on("click", ".recommendation--popup>div", function (event) {
  event.stopPropagation();
});

$(".Select-size li input").click(function () {
  $(".Select-size").slideUp();
  let title = $(this).attr("data-title");
  $(".variants-items .size-header span").text(title);

  $("body").removeClass("size_not_selected");

  $(`#Option${$(this).attr('data-position')},.enable_ajaxs-true`)
    .val($(this).attr("data-title"))
    .trigger("click");
   
});
$("span.close__size").click(function () {
  $("body").removeClass("size_not_selected");
});

$(".product-form__color-swatches button").click(function () {

  $(`#Option${$(this).attr('data-position')}`)
    .val($(this).attr("data-product-swatch-option"))
    .trigger("click");
});

$(".product_option-input input").click(function () {
  $(this).parent().parent().slideUp();
  $('.cartDrawer--overflow').css('overflow','auto');
  let _this = $(this),
    _this_val = _this.data("value"),
    selectors = $(this).parents(".selectors").find(".fd").attr("data-select");

  var selectedOptions = "";
  _this
    .parents(".products--list")
    .find(".selectors input:checked")
    .each(function (i) {
      if (selectedOptions == "") {
        selectedOptions = $(this).data("value");
      } else {
        selectedOptions = selectedOptions + " / " + $(this).data("value");
      }
    });

  _this
    .parents(".products--list")
    .find("select option")
    .each(function (i) {
      let _this2 = $(this),
        _this_val2 = _this2.data("title");
      if (selectedOptions == _this_val2) {
        let _this28 = _this2.attr("value");
        addItemToCarts(_this28, 1);
      }
    });
});

$(".product_option--items li,.size__recommended li").click(function () {
  $(this).addClass("active_swatch").siblings().removeClass("active_swatch");
  let _this = $(this);
  setTimeout(function () {
    let _this_val = _this.data("value");
    var selectedOptions = "";
    _this
      .parents(".products--list")
      .find("li.active_swatch")
      .each(function (i) {
        if (selectedOptions == "") {
          selectedOptions = $(this).data("value");
        } else {
          selectedOptions = selectedOptions + " / " + $(this).data("value");
        }
      });

    _this
      .parents(".products--list")
      .find("select option")
      .each(function (i) {
        let _this2 = $(this),
          _this_val2 = _this2.data("title");

        if (selectedOptions == _this_val2) {
          let _this28 = _this2.attr("value");

          _this
            .parents(".products--list")
            .find(".recommendation--popup-header span")
            .text(_this2.attr("data-price"));
          addItemToCarts(_this28, 1);
        }
      });
  }, 500);
});
$("[data-add-cart]").click(function () {
  $('.cartDrawer--overflow').css('overflow','auto');
  let _this_val = $(this).data("id");
  addItemToCarts(_this_val, 1);
});

    }
    function clearCartDrawer() {
      $(".ajax-cart--products").html("");
    }
    function openCartDrawer() {
      $(".ajax-cart__drawer").addClass("drawer-open");
            $("html").addClass("drawer-opened");
    }

    function closeCartDrawer() {
      $("html").removeClass("drawer-opened");
      $(".ajax-cart__drawer").removeClass("drawer-open");

    }
    function openCartOverlay() {
      $(".js-ajax-cart-overlay").fadeIn();
    }

    function closeCartOverlay() {
      $(".js-ajax-cart-overlay").fadeOut();

    }
    function closeCartModle() {
      $(".ajax-cart__modal").fadeOut();

    }
    
    function cartDrawerQuantityAdd(){
    
      jQuery('.qtyplus').click(function(event) {
      event.preventDefault();
        
        var variant_id = $(this).parents(".ajax-cart-productContent").data("variant-id");
            addItemToCarts( variant_id, 1, "1", "Months");
       
                });
    
    }
    function cartDrawerQuantityClose(){
        
      jQuery('.qtyminus').click(function(event) {
      event.preventDefault();
        
        var variant_id = $(this).parents(".ajax-cart-productContent").data("variant-id");
        var qut = $(this).parents(".ajax-cart-productContent").find("#quart").val() - 1;
            removeItemToCarts( variant_id, qut, "1", "Months");
    });
    }
    
    
         function removeItemToCarts(variant_id, qty, frequency, unit_type) {     
    data = {
      "id": variant_id,
      "quantity": qty
    }
      $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: data,
        dataType: 'json',
        success: function(cart) {
          if ((typeof callback) === 'function') {
            callback(cart);
          } else {
            fetchCart();

          }
        },
      });
     }
      function addItemToCarts(variant_id, qty, frequency, unit_type) {
    data = {
      "id": variant_id,
      "quantity": qty
    }
    
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
        success: addToCartOk,
        error: addToCartFail,
    });
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
    	bubbles: true    
 	 }));
    $('.cartDrawer--overflow').css('overflow','auto');
  }
    
    function cartCountIcon(){
           var  singleItemVlaue = 0;
                $(".ajax-cart-item__single").each(function() {
var singleItem = $(this);

    
                  singleItemVlaue += parseInt(singleItem.find("#quart").val());
                 cartCounter.html(parseInt(singleItemVlaue));
          
    });
    }
    
    
    jQuery('.quick-cart__trigger').click(function(event) {
      event.preventDefault();
      openCartDrawer();
      openCartOverlay();
      fetchCart();
    });
    jQuery('.js-ajax-cart-overlay').click(function() {
      closeCartOverlay();
      closeCartDrawer();
      closeCartModle();
      cartCountIcon();
    });
    jQuery('.ajax-cart-modal__close ').click(function() {
      
      closeCartModle();
    });

    jQuery('.js-ajax-cart-drawer-close svg').click(function() {
      closeCartDrawer();
      closeCartOverlay();
      cartCountIcon();


          });
   